const Text = (props: any) => {
  const { children } = props

  return children?.[1] || '-'
}

export default Text
